$w.onReady(function () {
	// TODO: write your page related code here...

let typeElements = $w("Button");
let firstOfType = typeElements[0];
console.log(firstOfType)
    // fbq('track', 'Schedule');

});
